module.exports = __webpack_public_path__ + "4543760414e719c1f272a460137f0c18.svg";